import type {
  CloudinaryAsset,
  SanityImage,
} from '@bulknutrients/bulk-shared-lib/interfaces/Sanity';
import { isCloudinaryAsset } from '@bulknutrients/bulk-shared-lib/lib/images';

import { CustomImage } from '@components/Media/Image/Image';
import type { PortableTextTypeComponentProps } from '@portabletext/react';

export function ImageSetRenderer(
  props: PortableTextTypeComponentProps<{
    _type: string;
    width: number;
    images: Array<SanityImage | CloudinaryAsset>;
  }>
) {
  return (
    <div className="flex flex-wrap items-center justify-center gap-5">
      {props.value.images?.map((image) => (
        <CustomImage
          image={image}
          width={props.value.width}
          height={props.value.width}
          key={
            isCloudinaryAsset(image)
              ? image._key
              : (image as SanityImage).asset._ref
          }
        />
      ))}
    </div>
  );
}
